

































import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDialog from '@core/components/AppDialog.vue'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppSmartSelect from '@core/components/AppSmartSelect.vue'
import API from '@core/services/API'
import { cid, container, inject } from 'inversify-props'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { IProjectSettings } from '@master/config/IProjectSettings'
import { IUIOptionsService } from '@master/services/IUIOptionsService'
import { IProjectInfo } from '@master/config/IProjectInfo'

interface Email {
  clientEmail: string;
  name?: string;
  kycFormOid: string;
  clientIndex: 0 | 1;
  attributeSet: AttributeSet[];
}

type AttributeSet = 'personal' | 'financial' | 'property'

@Component({
  components: {
    AppDialog,
    AppRadioSelection,
    AppSmartSelect
  }
})
export default class AppNewClientSingpass extends Vue {
  @Prop() readonly isShowName!: boolean
  @Prop() readonly clientIndex: 0 | 1

  private name = ''
  private email = ''
  private myInfoAttributes = 1

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private $api: API

  @inject()
  private projectSettings: IProjectSettings

  @inject()
  private projectInfo: IProjectInfo

  get options () {
    const uiOptionsService = container.get<IUIOptionsService>(cid.IUIOptionsService)
    return uiOptionsService.myinfoAttributeOptions()
  }

  setValue (value) {
    if (!value) { // to disable re-select option
      return
    }
    this.myInfoAttributes = value
  }

  async sendEmail () {
    if (this.isShowName && this.name.length === 0) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Please key in name'
      })
      return
    }

    if (this.email.length === 0) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Please key in email'
      })
      return
    }

    const attributeSet: AttributeSet[] = ['personal']

    if (this.myInfoAttributes === 1) {
      if (this.projectSettings.useMyinfoProperty) {
        attributeSet.push('property')
      }
      attributeSet.push('financial')
    }

    const data: Email = {
      clientEmail: this.email,
      kycFormOid: this.isShowName ? 'new' : this.$route.params.formOid,
      clientIndex: this.isShowName ? 0 : this.clientIndex,
      attributeSet: attributeSet
    }
    if (this.isShowName) {
      data.name = this.name
    }
    const { success, error } = await this.$api.myInfo.sendAuthorizationEmail(data)

    if (error) {
      await this.uiService.alert.show({
        type: 'error',
        message: error
      })
      return
    }
    await this.uiService.alert.show({
      type: 'success',
      message: success
    })
    this.$emit('close')
  }

  get companyMyInfoEmail () {
    return this.projectInfo?.myInfoSentEmail || 'do-not-reply@wenconsulting.com'
  }

  get mailTo () {
    return 'mailto:' + this.companyMyInfoEmail
  }

  async mounted () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
    this.myInfoAttributes = this.options.length > 0 ? Number(this.options[0].value) : 1
  }
}
